// extracted by mini-css-extract-plugin
module.exports = {"studioIcon":"StudioLink_studioIcon__uu0xf","mobileHiddenIconContainer":"StudioLink_mobileHiddenIconContainer__QxLYR","leftToRight":"StudioLink_leftToRight__o_gOP"};